export default __webpack_public_path__ + "static/media/levis.0d68f3cc.png";